import { render, staticRenderFns } from "./AddResidentsToBatchForm.vue?vue&type=template&id=9ad901be&scoped=true"
import script from "./AddResidentsToBatchForm.vue?vue&type=script&lang=js"
export * from "./AddResidentsToBatchForm.vue?vue&type=script&lang=js"
import style0 from "./AddResidentsToBatchForm.vue?vue&type=style&index=0&id=9ad901be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad901be",
  null
  
)

export default component.exports